import { actionTypes } from 'app/types/action_types';

const initialState = {};

const mapPayload = (state, payload) => ({
  ...state,
  faqUnreleasedImageryHtml: payload.faqUnreleasedImageryHtml,
  faq: payload.faqUnreleasedImagery,
  editorialLicenseFormUrl: payload.editorialLicenseFormUrl,
});

// eslint-disable-next-line default-param-last
const faqUnreleasedImageryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapPayload(state, action.payload);
    default:
      return state;
  }
};

export default faqUnreleasedImageryReducer;
